import React, { useState } from "react";
import { Link } from "react-router-dom";
import Admissionleft from "./Admissoinleft";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import Fade from "react-bootstrap/Fade";

function Mtech_AdmissionELe() {
    const [aboutOpen, setAboutOpen] = useState(true);
    const [datesOpen, setDatesOpen] = useState(false);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    const [sectionOpen, setSectionOpen] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);

    const handleClick = (event) => {
        setAboutOpen(false);
        setDatesOpen(false);
        setGuidelinesOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        setSectionOpen(false);
        setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    };

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className="c-left custom-padding-color">
                        <Admissionleft activeIndex={4} />
                    </Col>

                    <Col md={8} className="c-right">
                        <div className="c-heading">
                            <h3>Master of Public Policy</h3> <br />
                        </div>
                        <h4 className="mb-20">
                            Admission to the MPP programme will be done through
                            two tracks:
                        </h4>

                        <Row className="mb-5">
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button"
                                    onClick={() => handleClick(setAboutOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}
                                >
                                    About
                                </Button>
                            </Col>
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button"
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}
                                >
                                    Dates
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setGuidelinesOpen)
                                    }
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}
                                >
                                    Guidelines
                                </Button>
                            </Col>

                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}
                                >
                                    Categories
                                </Button>
                            </Col> */}

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setEligiblityOpen)
                                    }
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}
                                >
                                    Eligiblity
                                </Button>
                            </Col>

                            {/* financial */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setFinancialOpen)
                                    }
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}
                                >
                                    Financial Assistance
                                </Button>
                            </Col>
                            {/* section */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}
                                >
                                    Selection
                                </Button>
                            </Col>
                            {/* Documents */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setDocumentsOpen)
                                    }
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}
                                >
                                    Documents
                                </Button>
                            </Col>

                            {/* Fees */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}
                                >
                                    Fees
                                </Button>
                            </Col>

                            {/* Apply Online */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button
                                    className="btn-sm c-button "
                                    onClick={() =>
                                        handleClick(setApplyonlineOpen)
                                    }
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}
                                >
                                    Apply Online
                                </Button>
                            </Col>
                        </Row>

                        {/* about */}
                        <div>
                            {aboutOpen && (
                                <Fade in={aboutOpen}>
                                    <div>
                                    {/* <p className="fw-bold"> <span className="glowing-text">Orientation Program for MPP on July 26, 2024 - {" "}
                                    <Link to={"https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_Mtech_Msc_MPP_2024.pdf"} target="_blank;" className="c-link"> Click here </Link></span> </p> */}

                                        <h4>
                                            Introduction to the Masters of
                                            Public Policy (MPP) at IITT
                                        </h4>

                                   

                                        <p>
                                            IIT Tirupati has started a graduate
                                            program in Public Policy to meet the
                                            growing demand for policy
                                            professionals in India and to
                                            diversify the intellectual space at
                                            IIT Tirupati with the goal of
                                            producing academics and
                                            professionals who can contribute to
                                            the sustainable development of the
                                            nation.
                                        </p>
                                        <p>
                                            <b>Structure of the Programme</b>
                                        </p>
                                        <p>
                                            <b>
                                                The programme will be of 4
                                                semesters duration and will
                                                consist of:
                                            </b>
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                Core courses to be compulsorily
                                                taken by all candidates
                                            </li>
                                            <li>
                                                Elective courses in 3 streams
                                                depending on the choice of the
                                                candidate
                                            </li>
                                            <li>Dissertation</li>
                                        </ul>
                                        <p>
                                            The semester-wise plan for the
                                            programme can be found at this{" "}
                                            <Link to={"https://files.iittp.ac.in/pdfs/curriculum/2022/MPP_Curriculum.pdf"} target="_blank;" className="c-link"> Link </Link>
                                        </p>
                                        <p>
                                            The programme has three streams of
                                            specialization. (i) Science and
                                            Management of Sustainability is
                                            multidisciplinary and can be opted
                                            by all enrolled students. But
                                            students opting for (ii) Data
                                            Science must have prior B. Tech in
                                            Computer Science while those opting
                                            for (iii) Sustainability and
                                            Engineering must have B. Tech in
                                            Civil or Environmental Engineering.
                                        </p>
                                        <p>
                                            <b>
                                                Prospects and Opportunities in
                                                the Future
                                            </b>
                                        </p>
                                        <p>
                                            MPP programme is multi-disciplinary
                                            and its graduates will be exposed to
                                            a range of skills specially geared
                                            towards the policymaking arena. MPP
                                            degree will enable students to work
                                            with a variety of policy-oriented
                                            organizations in the private, public
                                            as well as non-profit sector as
                                            consultants, policy researchers,
                                            program analysts etc.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*dates */}
                        <div>
                            {datesOpen && (
                                <Fade in={datesOpen}>
                                    <div>
                                        <Table
                                            bordered
                                            responsive
                                            className="mt-3"
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        colSpan="2"
                                                        className="text-center"
                                                    >
                                                        <h4 className="text-primary">
                                                            Important Dates
                                                        </h4>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        Opening date for online
                                                        application
                                                    </td>
                                                    <td>20.03.2026 10.00 AM Friday</td>
                                                    {/* <td>
                                                        <b>Wednesday, March 20, 2024 at 10 AM</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Closing date for online
                                                        application
                                                    </td>
                                                    <td>20.04.2026 05.00 PM Monday</td>
                                                    
                                                    {/* <td>
                                                        <b>Friday, April 19, 2024 upto 5 PM</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Date of Written Test for Track 2
                                                    </td>
                                                    <td><b className="c-link glowing-text">Completed</b></td>
                                                    {/* <td>
                                                        <b>11-May-2024</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                    <td>
                                                    Final Interview for Track - 1 and Track - 2
                                                    </td>
                                                    <td><b className="c-link glowing-text">Completed</b></td>
                                                    {/* <td>
                                                        <b>11-May-2024</b>
                                                    </td> */}
                                                </tr>

                                                <tr>
                                                    <td>
                                                    Announcement of results
                                                    </td>
                                                    <td>
                                                    <b className="c-link glowing-text"><Link className="c-link" target="_blank" to="https://iittp.ac.in/msphd-admissions">Click Here</Link></b>
                                                    </td>
                                                    {/* <td>
                                                        <b>26- May-2024 to 28-May-2024</b>
                                                    </td> */}
                                                </tr>
                                                <tr>
                                                <td>Reporting to Campus</td>
                                            
											<td>27th July 2026</td>
                                             </tr>
                                                <tr>
                                                <td>In-Person Registration cum Document Verification at IIT Tirupati</td>
                                            
											<td>29th July 2026 (FN)</td>
                                             </tr>
                                                <tr>
                                                    <td>
                                                        Orientation Program
                                                    </td>
                                                    {/* <td><b>will be updated soon</b></td> */}
                                                    <td>30th July 2026 (AN)</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Commencement of classes
                                                    </td>
                                                    {/* <td><b>will be updated soon</b></td> */}
                                                    <td>3rd August 2026</td>
                                                </tr>
                                                
                                            </tbody>
                                        </Table>

                                        <b>
                                            Please write to{" "}
                                            <Link
                                                to="mailto:admissions@iittp.ac.in"
                                                className="c-link"
                                            >
                                                admissions@iittp.ac.in
                                            </Link>{" "}
                                            or call 0877 250 3532 for  any questions or queries regarding admission related matters.{" "}
                                        </b>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Guidelines*/}

                        <div>
                            {guidelinesOpen && (
                                <Fade in={guidelinesOpen}>
                                    <div className="c-lineheight2dot5">
                                        <h4 className="mb-3">
                                            Important Guidelines
                                        </h4>

                                        <ol className="list-group list-group-numbered">
                                            <li>
                                                The link to the online
                                                application form is available in
                                                the Apply Online tab. After
                                                filling out the form, please
                                                take a print and keep it for
                                                your record.
                                            </li>

                                            <li>
                                                {" "}
                                                The application fee is as
                                                follows:
                                                <ul className="myulcustarrow">
                                                    <li>
                                                        {" "}
                                                        GEN/EWS/OBC-NCL Male
                                                        candidates : Rs.400/-{" "}
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        GEN/EWS/OBC-NCL Female
                                                        candidates : Rs.200/-
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        SC/ST and PwD candidates
                                                        : Rs.200/-
                                                    </li>
                                                </ul>
                                                <em
                                                    style={{ color: "#2009df" }}
                                                >
                                                    The application fee is
                                                    non-refundable. Please
                                                    ensure to save the payment
                                                    reference number.
                                                </em>
                                            </li>

                                            <li>
                                                {" "}
                                                Candidates called for the
                                                written test/interview must
                                                produce a copy of the
                                                application submitted online
                                                along with originals and
                                                photocopies of the relevant
                                                certificates.
                                            </li>

                                            <li>
                                                {" "}
                                                Reservation/concession/relaxations
                                                for EWS/OBC-NCL/SC/ST/PwD and
                                                Kashmiri- Migrants (KM),
                                                including Kashmiri
                                                Pandits/Kashmiri Hindu Families:
                                                As per the Government of India
                                                rules. A copy of a valid
                                                OBC-NCL/ST/SC/EWS/PwD
                                                certificate must be uploaded
                                                during the ONLINE application
                                                and must be submitted at the
                                                time of admission.
                                            </li>
                                            <li>
                                                {" "}
                                                A Statement of Purpose (SoP)
                                                must be uploaded along with the
                                                online application. The
                                                guidelines for preparing the SoP
                                                are available at this{" "}
                                                <a
                                                    href="https://files.iittp.ac.in/pdfs/admissions/2023/docx/1.docx"
                                                    target="_blank;"
                                                >
                                                    Link
                                                </a>
                                            </li>
                                            <li>
                                                {" "}
                                                At the time of physical
                                                reporting to the Institute,
                                                candidates must submit
                                                self-attested copies of the
                                                relevant certificates as
                                                specified in the Documents tab,
                                                failing which admission will
                                                stand cancelled.
                                            </li>
                                            <li>
                                                {" "}
                                                Please make all files ready with
                                                following format and size before
                                                going to file upload:
                                                <ul className="myulcustarrow">
                                                    <li>
                                                        {" "}
                                                        Passport size Photo
                                                        (jpg, jpeg, png), size
                                                        &lt;=500 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        Signature (format jpg,
                                                        jpeg, png) size &lt;=
                                                        200 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        10th Certificate (pdf)
                                                        size &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        12th / Diploma /
                                                        Equivalent Certificate
                                                        (pdf) size &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        Qualifying UG Degree
                                                        Certificate (pdf) size
                                                        &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        Consolidated UG mark
                                                        sheet (pdf) size
                                                        &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        Community Certificate if
                                                        applicable (pdf) size
                                                        &lt;= 1024 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        PwD Certificate if
                                                        applicable (pdf) size
                                                        &lt;= 1024 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        Applicable National
                                                        Level Exams/GATE (pdf,
                                                        jpg, jpeg) each size
                                                        &lt;= 1024 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        SoP/Research Proposal,
                                                        (pdf) size &lt;=1024 KB
                                                    </li>
                                                    <li>
                                                        {" "}
                                                        First page of
                                                        publication, if
                                                        applicable (pdf, jpg,
                                                        jpeg) each size &lt;=
                                                        1024 KB
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                {" "}
                                                Please visit the institute’s
                                                website regularly for important
                                                announcements and results.
                                            </li>
                                            <li>
                                                In case of any queries, please
                                                write to{" "}
                                                <a href="mailto:admissions@iittp.ac.in">
                                                    admissions@iittp.ac.in
                                                </a>{" "}
                                                or call 0877-2503531 (9.00 AM to
                                                5.30 PM on all working days).
                                            </li>
                                        </ol>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && (
                                <Fade in={eligiblityOpen}>
                                    <div>
                                        <h4>Eligibility</h4>
                                        <ul className="myulcustarrow">
                                            <li>
                                                {" "}
                                                Candidates who have already
                                                obtained or are likely to obtain
                                                at the end of the academic year
                                                a Bachelor's degree (after 10+2)
                                                or equivalent in any subject
                                                from a recognized university or
                                                institute are eligible to apply
                                                for admission to the MPP
                                                programme offered by the
                                                Institute.
                                            </li>
                                            <li>
                                                {" "}
                                                At least 55% marks (taking into
                                                account all subjects, including
                                                languages and subsidiaries, all
                                                years combined) for General
                                                /OBC/ EWS category candidates
                                                and at least 50% aggregate marks
                                                (taking into account all
                                                subjects, including languages
                                                and subsidiaries, all years
                                                combined) for SC/ST and PwD
                                                category candidates in the
                                                qualifying degree.
                                            </li>
                                        </ul>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                            {financialOpen && (
                                <Fade in={financialOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Financial Assistance
                                        </h4>
                                        <p>
                                            Financial assistance in the form of
                                            Half-Time Teaching Assistantship
                                            (HTTA) at the rate of Rs.12,400/-
                                            p.m. (tenable for a maximum period
                                            of 24 months) will be awarded to
                                            Indian Nationals admitted under
                                            Track 1, subject to Institute rules.
                                            Students receiving HTTA are required
                                            to assist for 8 hours/week in the
                                            academic activities of the
                                            department such as laboratory
                                            demonstration, tutorials, evaluation
                                            of assignments, test papers,
                                            seminars, research projects etc.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Section*/}

                        <div>
                            {sectionOpen && (
                                <Fade in={sectionOpen}>
                                    <div>
                                        <h4>Selection Procedure</h4>
                                        <p>
                                            Admission to the MPP programme will
                                            be done through two tracks:
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                Track 1: Applicants who have
                                                taken the GATE exam and have
                                                valid GATE exam scores
                                            </li>
                                            <li>
                                                Track 2: Applicants who have not
                                                taken GATE exam Applicants will
                                                only be considered for one track
                                                at a time during an admission
                                                year. These two tracks will be
                                                treated separately for the
                                                generation of the final merit
                                                list.
                                            </li>
                                        </ul>
                                        <p>
                                            Track 1. For eligible applicants who
                                            have taken the GATE exam and have
                                            valid GATE exam scores
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                Applicants must have a valid
                                                GATE score to be shortlisted for
                                                the subsequent round of
                                                selection.
                                            </li>
                                            <li>
                                                Only GATE applicants at or above
                                                the cut-off defined by the
                                                Institute will be asked to
                                                undertake personal interviews.
                                            </li>
                                            <li>
                                                A final merit list will be
                                                generated based on the GATE
                                                score and interview. Criteria
                                                for admission as full-time
                                                students including the relevant
                                                cut-offs will be decided by the
                                                Institute, with relaxation for
                                                reserved category applicants in
                                                accordance with the rules of the
                                                Government of India. Amendments
                                                to the admissions criteria will
                                                be made from time to time by the
                                                Institute.
                                            </li>
                                        </ul>
                                        <p>
                                            Track 2. For eligible applicants who
                                            have not taken the GATE exam
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>
                                                Applicants who do not have a
                                                valid GATE score will appear for
                                                the written test.
                                            </li>
                                            <li>
                                                Only those applicants at or
                                                above the cut-off for the
                                                written test marks will move to
                                                the final interview stage.
                                            </li>
                                            <li>
                                                A final merit list will be
                                                generated based on the marks
                                                obtained in the written test and
                                                interview. Criteria for
                                                admission as full-time students,
                                                including the relevant cut-offs,
                                                will be decided by the
                                                Institute, with relaxation for
                                                reserved category applicants in
                                                accordance with the rules of the
                                                Government of India.
                                            </li>
                                        </ul>
                                        <p>
                                            <em className="text-orange">Note</em>: Amendments to the
                                            admissions criteria will be made
                                            from time to time by the Institute.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Documents*/}

                        <div>
                            {documentsOpen && (
                                <Fade in={documentsOpen}>
                                    {/* <div>
                                        <h4 className="mb-4">
                                            Original Documents to be submitted
                                            for Verification:
                                        </h4>
                                        <p>
                                            <b>At the time of admission:</b>
                                        </p>
                                        <p>
                                            Self-attested copies of the
                                            following documents must be
                                            submitted at the time of admission.
                                        </p>

                                        <ul className="myulcustarrow">
                                            <li>Copy of application</li>
                                            <li>Offer of admission.</li>
                                            <li>
                                                Birth Certificate / SSC / SSLC
                                                certifcate as proof of Name and
                                                Date of birth
                                            </li>
                                            <li>
                                                Any valid government ID proof
                                                such as Aadhaar, PAN, Passport,
                                                Driving License, etc.{" "}
                                            </li>
                                            <li>
                                                Degree certificates /
                                                Provisionals / Course completion
                                                certificates / Grade Cards /
                                                Marksheets of all the degrees
                                                obtained.
                                            </li>
                                            <li>
                                                Community Certificate in the
                                                case of SC/ST/OBC-NCL/EWS
                                                candidates issued by the
                                                Competent Authority in the
                                                prescribed GoI format.
                                            </li>
                                            <li>
                                                Authorized Doctor’s Certificate
                                                with disability descriptions in
                                                the case of Person with Disabled
                                                (PwD) candidates.
                                            </li>
                                            <li>
                                                Copy of valid GATE score (if
                                                applicable).
                                            </li>
                                        </ul>
                                        <p>
                                            Important: Please note that the
                                            originals of all the above
                                            certificates should be produced at
                                            the time of physical verification.
                                        </p>
                                    </div> */}
                                    <div>
                                        <h4>
                                            Original Documents to be submitted
                                            for Verification:
                                        </h4>
                                        <p>
                                            <b>
                                                At the time of Interview and/or
                                                Written Test:
                                            </b>
                                        </p>
                                        <p>
                                            Self-attested copies of the
                                            following documents must be
                                            submitted at the time of the
                                            interview and/or written test.
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>Copy of application</li>
                                            <li>
                                                Degree certificates /
                                                Provisionals / Course completion
                                                certificates / Grade Cards /
                                                Marksheets of all the degrees
                                                obtained.
                                            </li>
                                            <li>
                                                Community Certificate in the
                                                case of SC/ST/OBC-NCL/EWS
                                                candidates issued by the
                                                Competent Authority in the
                                                prescribed GoI format.
                                            </li>
                                            <li>
                                                Authorized Doctor’s Certificate
                                                with disability descriptions in
                                                the case of Person with Disabled
                                                (PwD) candidates.
                                            </li>
                                            <li>
                                                Copy of valid GATE score (if
                                                applicable)
                                            </li>
                                        </ul>
                                        <p style={{ color: "#2009df" }}>
                                            Important: Please note that the
                                            originals of all the above
                                            certificates should be produced at
                                            the time of physical verification.
                                        </p>
                                        <p>
                                            <b>At the time of Admission:</b>
                                        </p>
                                        <p>
                                            Self-attested copies of the
                                            following documents must be
                                            submitted at the time of admission /
                                            registration
                                        </p>
                                        <ul className="myulcustarrow">
                                            <li>Offer of admission</li>
                                            <li>
                                                Birth Certificate / SSC / SSLC
                                                certificate as proof of Name and
                                                Date of birth
                                            </li>
                                            <li>
                                                Any valid government ID proof
                                                such as Aadhaar, PAN, Passport,
                                                Driving License, etc.
                                            </li>
                                            <li>
                                                Degree certificates /
                                                Provisionals / Course completion
                                                certificates / Grade Cards /
                                                Marksheets of all the degrees
                                                obtained.
                                            </li>
                                            <li>
                                                Community Certificate in the
                                                case of SC/ST/OBC-NCL/EWS
                                                candidates issued by the
                                                Competent Authority in the
                                                prescribed GoI format.
                                            </li>
                                            <li>
                                                Degree certificates /
                                                Provisionals / Course completion
                                                certificates / Grade Cards /
                                                Marksheets of all the degrees
                                                obtained.
                                            </li>
                                        </ul>
                                        <p style={{ color: "#2009df" }}>
                                            Important: Please note that the
                                            originals of all the above
                                            certificates should be produced at
                                            the time of physical verification.
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Fees*/}

                        <div>
                            {feesOpen && (
                                <Fade in={feesOpen}>
                                    <div>
                                        <h4 className="mb-4">
                                            Fees and Deposits
                                        </h4>
                                        <p>
                                            The applicable tuition and other
                                            fee/ deposits for Master of Public
                                            Policy (MPP) students is available
                                            at the following{" "}
                                            <Link
                                                to="/fee-structure"
                                                className="c-link"
                                            >
                                                link
                                            </Link>
                                            .
                                        </p>
                                    </div>
                                </Fade>
                            )}
                        </div>

                        {/*Apply Online*/}

                        <div>
                            {applyonlineOpen && (
                                <Fade in={applyonlineOpen}>
                                    <div>
                                        <h4 className="mb-4">Apply Online</h4>
                                        <p>
                                            <b>To Apply Online</b> :{" "}
                                            <Link to="https://iittp.plumerp.co.in/prod/iittirupati/mppapplication" target="_blank" className="c-link">
                                                <b className="text-maroon">Click here to apply</b>
                                            </Link>
                                           
                                            {/* <b className="text-maroon">Will be updated soon </b> */}
                                        </p>
                                        {/* <p> <b>To login and download application</b> :{" "}
                                            <Link to="https://iittp.plumerp.co.in/prod/iittirupati/mppapplication"  target="_blank" className="c-link">
                                                <b className="text-maroon">Click here to apply </b>
                                            </Link></p> */}
                                    </div>
                                </Fade>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Mtech_AdmissionELe;
